module.exports = {
      id: "angle-left-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#angle-left",
      toString: function () {
        return this.url;
      }
    }